module.exports = __webpack_public_path__ + "media/images/shared/icon_instagram-52c20862ef96355b164977362413abbf.svg";